import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'

export const Container = styled.div`
	border-radius: 4px;
	background-color: ${helpers.color.input.chipBackground};
	font-size: 13px;
	line-height: 18px;
	display: flex;
	align-items: center;
	column-gap: 4px;
	cursor: default;
	padding-left: 6px;
	min-width: 0;
	min-height: 24px;
	margin: -4px 0;

	&:has(> svg) {
		padding-left: 4px;
	}

	> span {
		padding: 4px 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	> svg {
		flex-shrink: 0;
		height: 18px;
		width: 18px;
	}
`
